import React from "react";
import "./MaintenancePage.scss";
import edubayLogo from "assets/images/Logo/EduBay_logo.svg";
import MaintenanceImage from "assets/images/maintenance_image.png";

const MaintenancePage: React.FC = () => {
  return (
    <section className="maintenance_section">
      <div className="maintenance_wr">
        <div className="maintenance_logo">
          <img src={edubayLogo} height="40" alt="Edubay Logo" />
        </div>

        <div className="maintenance_image">
          <img src={MaintenanceImage} alt="EduBay is under maintenance" />
        </div>

        <div className="maintenance_content">
          <h1>We'll Be Back Soon!</h1>
          <h2>EduBay is currently under maintenance.</h2>
          <span className="maintenance_divider" aria-hidden="true" />
          <p>
            Pardon our dust. EduBay is getting polished up. <br />
            We’re improving EduBay to enhance your learning experience.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MaintenancePage;
